import types from "../actions/action-types";

export default (state = [], action) => {
  switch (action.type) {
    case types.LOGIN:
    case `${types.LOGIN}_REJECTED`:
      return {
        ...state,
        loginResponse: action.updatePayload,
      };

    default:
      return state;
  }
};
